import { render, staticRenderFns } from "./patientLungDetail.vue?vue&type=template&id=76803e6a&scoped=true"
import script from "./patientLungDetail.vue?vue&type=script&lang=js"
export * from "./patientLungDetail.vue?vue&type=script&lang=js"
import style0 from "./patientLungDetail.vue?vue&type=style&index=0&id=76803e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76803e6a",
  null
  
)

export default component.exports